export default {
  // rule = { min: 0, max: 10 }
  length(rule = {}) {
    // eslint-disable-next-line no-prototype-builtins
    const has_max = rule.hasOwnProperty('max'), has_min = rule.hasOwnProperty('min');
    return v => {
      if (!v) v = '';
      const len = v.length;
      if (has_max && has_min) {
        return len >= rule.min && len <= rule.max || `长度介于 ${rule.min} 与 ${rule.max} 之间`;
      } else if (has_max) {
        return len <= rule.max || `长度不能超过 ${rule.max}`;
      } else if (has_min) {
        return len >= rule.min || `长度不能小于 ${rule.min}`;
      } else {
        return true
      }
    }
  },

  notEmpty(field = '内容') {
    return v => !!v || `${field}不能为空`
  }
}
